import { boxShadows, colors, mixin, sizes, zIndexValues } from "@hubrise/react-components"
import styled, { css } from "styled-components"

export const StyledMenu = styled.div`
  position: relative;
  cursor: pointer;
`

export const Dropdown = styled.ul`
  position: absolute;
  z-index: ${zIndexValues.dropdown};
  top: calc(100% + 1px);
  left: 0;
  background-color: ${colors.backgroundWhite};
  display: flex;
  flex-flow: column;
  border-radius: 0 0 ${sizes.borderRadius} ${sizes.borderRadius};
  box-shadow: ${boxShadows.medium};
  width: max-content;
`

export const DropdownItem = styled.li<{ disabled: boolean }>`
  padding: 0.75rem 1rem;
  transition: background-color 0.1s ease;
  ${mixin.clickable};

  ${(props) =>
    props.disabled &&
    css`
      cursor: default;
      color: ${colors.textLight};
    `}

  & + & {
    border-top: thin solid ${colors.borderLight};
  }

  :hover {
    ${(props) => !props.disabled && `background-color: ${colors.backgroundLight};`}
  }
`
